import { AddCircleOutline } from '@mui/icons-material'
import { Box, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CommonPageLayout } from 'src/components/common/CommonPageLayout'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'
import { MaintenanceTemplateType } from 'src/enums'
import { useGetEquipmentMaintenanceTemplates } from 'src/api/maintenanceTemplate'
import { IMaintenanceTemplate } from 'src/generated-types/maintenanceTemplate'
import MaintenanceTemplateTable from './MaintenanceTemplateTable'
import { useDialogCtx } from 'src/hooks/context-hooks'
import CreateMaintenanceTemplateForm from './CreateMaintenanceTemplateForm'

interface EquipmentMaintenanceTemplatesContainerProps {
  customerId: EntityId
}

const EquipmentMaintenanceTemplatesContainer = ({ customerId }: EquipmentMaintenanceTemplatesContainerProps) => {
  const { t: translate } = useTranslation(['maintenance'])
  const { data: equipmentMaintenanceTemplates } = useGetEquipmentMaintenanceTemplates(customerId)
  const { showDialog } = useDialogCtx()

  const onAdd = () => {
    showDialog(
      CreateMaintenanceTemplateForm,
      {
        componentProps: {
          customerId: customerId,
          type: MaintenanceTemplateType.Equipment,
        },
        opts: {
          maxWidth: 'lg',
          fullWidth: true,
        },
        isAutoCloseDisabled: true,
      },
      undefined,
      true,
    )
  }

  return (
    <CommonPageLayout
      height={'100%'}
      childrenProps={{ flex: 1 }}
      titleSection={{ subtitle: translate('equipment-templates', { ns: 'maintenance' }) }}
      topAction={[
        {
          buttonText: translate('addTemplate', { ns: 'maintenance' }),
          buttonIcon: <AddCircleOutline />,
          variant: 'outlined',
          shadowWeight: null,
          border: 0,
          onClick: onAdd,
        },
      ]}
    >
      <StyledContainer>
        <MaintenanceTemplateTable
          templates={equipmentMaintenanceTemplates as IMaintenanceTemplate[]}
          templatesType={MaintenanceTemplateType.Equipment}
          pop={() => { }}
          customerId={customerId}
        />
      </StyledContainer>
    </CommonPageLayout>
  )
}

export default EquipmentMaintenanceTemplatesContainer

export const StyledContainer = styled(Box)(({ theme }) => ({
  padding: '8px',
  backgroundColor: getThemeColor(theme, MUIThemeColors.white),
  borderRadius: '4px',
  flex: 1,
}))
